import {UserAvatarV2} from '@components/common/user-avatar-v2/user-avatar-v2'
import {UserProxy} from '@extensions/proxies/user-proxy'
import React from 'react'

interface Props {
  user: UserProxy
}

export const StatsTimelineRowUsername = (props: Props) => {
  const {user} = props

  return (
    <div className="flex items-center">
      <UserAvatarV2 {...user} hideStatus size={20} />
      <div className="flex-1 ml-4 mr-6 truncate">{user.userName}</div>
    </div>
  )
}
